import { render, staticRenderFns } from "./BrandSpetema.vue?vue&type=template&id=4d62732a&scoped=true&"
import script from "./BrandSpetema.vue?vue&type=script&lang=js&"
export * from "./BrandSpetema.vue?vue&type=script&lang=js&"
import style0 from "./BrandSpetema.vue?vue&type=style&index=0&id=4d62732a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d62732a",
  null
  
)

export default component.exports